import DataTableV2PaginatedMobile from '@/agilis/mobile/DataTableV2PaginatedMobile/DataTableV2PaginatedMobile.vue'
import ProductTable from '@/applications/sales/components/Product2Table/ProductTable'

export default {
  name: 'Product2TableMobile',

  props: {
    propTitle: String
  },
  mixins: [ProductTable],
  components: {
    DataTableV2PaginatedMobile
  }
}
